import { cva } from 'class-variance-authority';

export const button = cva(
  'rounded-s text-content-inverse focus:ring outline-none aria-disabled:bg-surface-disabled aria-disabled:text-content-disabled aria-disabled:cursor-not-allowed inline-flex items-center justify-center',
  {
    variants: {
      intent: {
        primary: 'bg-primary hover:bg-primary-hover active:bg-primary-active',
        secondary:
          'bg-secondary border border-strong text-content-subdued hover:bg-secondary-hover active:bg-secondary-active',
        ghost:
          'text-content-link bg-transparent hover:bg-secondary-hover active:bg-secondary-active',
        tertiary:
          'text-content-link bg-transparent hover:bg-tertiary-hover active:bg-tertiary-active',
        destructive:
          'bg-negative text-content-inverse hover:bg-negative-hover active:bg-negative-active ring-negative',
      },
      size: {
        large: 'py-s px-xl h-l text-button-l gap-x-s',
        small: 'py-xs px-m h-s text-button-s gap-x-xs',
        xSmall: 'py-0 px-0 text-button-xs gap-x-xxs',
      },
      width: {
        full: 'w-full',
        fit: 'w-fit',
      },
      // TODO: Remove `purpose` since we have a `ButtonIcon` component for icons.
      purpose: {
        trigger: 'aria-expanded:ring',
        icon: '',
      },
      textWrap: {
        wrap: 'text-wrap',
        nowrap: 'text-nowrap',
      },
    },
    compoundVariants: [
      {
        intent: 'ghost',
        size: 'large',
        class: '!px-s',
      },
      {
        intent: 'ghost',
        size: 'small',
        class: '!px-xs',
      },
      {
        intent: 'ghost',
        size: 'xSmall',
        class: '!px-0',
      },
      {
        purpose: 'icon',
        size: 'large',
        class: '!px-s',
      },
      {
        purpose: 'icon',
        size: 'small',
        class: '!px-xs',
      },
      {
        purpose: 'icon',
        intent: 'ghost',
        class: '!text-content',
      },
      {
        intent: 'tertiary',
        class: '!p-0',
      },
    ],
    defaultVariants: {
      intent: 'primary',
      size: 'large',
      textWrap: 'nowrap',
    },
  },
);
